import { PageWithoutHeader } from "@/components/Page";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Button from "../components/Button";
import VideoWatermarkGenerator from "../components/VideoWatermarkGenerator";
import { trackEvent } from "@/lib/amplitude";
import { useEffect, useRef } from "react";

export default function Conclusion() {
  const location = useLocation();
  const { t } = useTranslation();
  const hasTrackedPageView = useRef(false);
  const placeRef = window.localStorage.getItem("placeRef");

  const originalVideo = location.state?.originalVideo as File | undefined;

  useEffect(() => {
    if (!hasTrackedPageView.current) {
      hasTrackedPageView.current = true;
      trackEvent("success_page_viewed", {
        placeRef,
        hasWatermarkVideo: !!originalVideo,
      });
    }
  }, []);

  return (
    <PageWithoutHeader
      action={
        <Button
          onPress={() => {
            trackEvent("app_download_clicked", { placeRef, source: "success_page" });
            window.open("https://onelink.to/behnx6");
          }}
        >
          {t("conclusion.button")}
        </Button>
      }
    >
      <div className="flex flex-col bg-secondary pb-6 pt-8">
        <div className="flex max-w-md grow flex-col px-4 text-center">
          <div className="grow font-medium">
            <h1 className="whitespace-pre-wrap text-3xl font-semibold text-white">
              {t("conclusion.title")}
            </h1>

            <h2 className="mb-8 mt-6 whitespace-pre-wrap text-white">
              {t("conclusion.subtitle")}
            </h2>

            <span className="text-8xl">🥳</span>

            {originalVideo && (
              <div className="mt-8">
                <VideoWatermarkGenerator videoFile={originalVideo} />
              </div>
            )}
          </div>
        </div>
      </div>
    </PageWithoutHeader>
  );
}
